import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description NewFlat icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { NewFlat } from '@sravni/design-system-icons'
 *
 * <NewFlat />
 * ```
 */
var NewFlat = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "NewFlat", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M13.403 2h5.333v16h-16V2H8.07l3.666 3m-2.23 13v-7m0 0h2.769m-2.77 0H6.737m12 0h-3", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { NewFlat };
//# sourceMappingURL=NewFlat.js.map
